/**
 * Copyright (c) 2022 Schwäbische Werkzeugmaschinen GmbH
 *
 * @author Sebastian Roming
 * @since 5.0.0
 */
import { PaperToastElement } from '@polymer/paper-toast';
import { LdLoginMessages }   from './ld-login-messages';

// --------------------------------------------------------------------------------------
export const showToast = (message: string, toastElement?: PaperToastElement): void => {


  setTimeout(() => {
    const _toastElement             = toastElement ?? <PaperToastElement>document.querySelector('ld-login-application')!.shadowRoot!.querySelector('paper-toast#ld-login-toast');

    const _toastMessageElement      = _toastElement!.querySelector('.ld-login-toast-message');
    const _error                    = LdLoginMessages[message];
    _toastElement.style.borderTopColor = _error.error ? '#E4002B' : '#00e43d';

    _toastMessageElement!.innerHTML = _error.message;

    if(_error.toast_duration !== 0) {
      _toastElement.duration = _error.toast_duration;
    }

    _toastElement!.open();
  }, 500);

};
